import React, { useContext, useEffect, useState } from "react";
import Students from "../Templates/Home/Students/Students";
import { useNavigate } from "react-router-dom";
import useFetch from "../Hooks/useFetch";
import { listSchoolsURL, studentURL } from "../Hooks/URL";
import { userContext } from "../Contexts/userContext";

function StudentsPage() {
  const { contextData, setContextData } = useContext(userContext);
  const navigate = useNavigate();

  const [page, setPage] = useState(0);
  const [pageCount, setPageCount] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(20);
  const [searchData, setSearchData] = useState("");
  const [search, setSearch] = useState("");
  const [Filter, setFilter] = useState("");
  const [Open, setOpen] = useState(false);

  const [students, setStudents] = useState([]);
  const { data, loading, error } = useFetch(
    studentURL,
    page,
    rowsPerPage,
    search,
    null,
    null,
    Filter
  );

  useEffect(() => {
    if (!loading && !error && data) {
      setStudents(data.data);
      setPageCount(data.pagesCount);
    }
  }, [data, loading, error]);

  useEffect(() => {
    setContextData({ ...contextData, page: "students", data: "" });
  }, []);

  const handleChangePage = (event, newPage) => {
    setPage(newPage - 1);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  return (
    <Students
      role={contextData?.role}
      page={page}
      rowsPerPage={rowsPerPage}
      handleChangeRowsPerPage={handleChangeRowsPerPage}
      searchData={searchData}
      search={search}
      setSearchData={setSearchData}
      setSearch={setSearch}
      students={students}
      navigate={navigate}
      handleChangePage={handleChangePage}
      Open={Open}
      setOpen={setOpen}
      loading={loading}
      data={data}
      error={error}
      pageCount={pageCount}
      setStudents={setStudents}
      setFilter={setFilter}
    />
  );
}

export default StudentsPage;
